import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Empty, message, Row, Spin } from "antd";
import { BASE_URL } from "../common.ts";

function BypassRedirect() {
  const { kind, enqNo } = useParams();
  const [messageApi, contextHolder] = message.useMessage();
  const location = useLocation();
  

  useEffect(() => {
    const backendBaseUrl = BASE_URL.replace(/\/$/, "");
    window.location.href = `${backendBaseUrl}/link/${kind}/${enqNo}?bypass=true`;
  }, [kind,enqNo]);

  return (
    <>
      {contextHolder}
      <div style={{ height: "90vh", margin: "0" }}>
        <Row
          justify="center"
          align="middle"
          style={{
            padding: 16,
          }}
        >
          <Spin></Spin>
        </Row>
      </div>
    </>
  );
}

export default BypassRedirect;
